import React from 'react';
import { ReactComponent as SpinnerIcon } from '../../assets/svgs/spinner.svg';
import colors from '../../constants/colors.constants';

function Spinner() {
  return <SpinnerIcon color={colors.subTitle} />;
}

export default Spinner;
